import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import StructuredData from './components/StructuredData';
import LandingPage from './pages/LandingPage';
import Erstgespraech from './pages/Erstgespraech';
import ConfirmAppointment from './pages/ConfirmAppointment';

// ScrollToTop component to handle scroll on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
import DigitaleBuchhaltung from './pages/DigitaleBuchhaltung';
import SteuerCompliance from './pages/SteuerCompliance';
import AmazonOptimierung from './pages/AmazonOptimierung';
import MultichannelVertrieb from './pages/MultichannelVertrieb';
import Preisoptimierung from './pages/Preisoptimierung';
import Lagerverwaltung from './pages/Lagerverwaltung';
import Prozessautomatisierung from './pages/Prozessautomatisierung';
import SeoSeaOptimierung from './pages/SeoSeaOptimierung';
import KiWerbung from './pages/KiWerbung';
import InfluencerMarketing from './pages/InfluencerMarketing';
import KiKundenservice from './pages/KiKundenservice';
import GpsrProduktsicherheit from './pages/GpsrProduktsicherheit';
import CustomSoftwareDashboards from './pages/CustomSoftwareDashboards';
import WebseitenWebApps from './pages/WebseitenWebApps';
import BigDataMigration from './pages/BigDataMigration';
import WebsiteCrawler from './pages/WebsiteCrawler';
import KiVertriebsagenten from './pages/KiVertriebsagenten';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StructuredData />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/erstgespraech" element={<Erstgespraech />} />
          <Route path="/admin/confirm-appointment/:appointmentId" element={<ConfirmAppointment />} />
          <Route path="/digitale-buchhaltung" element={<DigitaleBuchhaltung />} />
          <Route path="/steuer-compliance-oss" element={<SteuerCompliance />} />
          <Route path="/amazon-optimierung" element={<AmazonOptimierung />} />
          <Route path="/multichannel-vertrieb" element={<MultichannelVertrieb />} />
          <Route path="/preisoptimierung-angebotserstellung" element={<Preisoptimierung />} />
          <Route path="/lagerverwaltung-logistik" element={<Lagerverwaltung />} />
          <Route path="/prozessautomatisierung" element={<Prozessautomatisierung />} />
          <Route path="/seo-sea-optimierung" element={<SeoSeaOptimierung />} />
          <Route path="/ki-werbung-social-media" element={<KiWerbung />} />
          <Route path="/influencer-marketing-akquise" element={<InfluencerMarketing />} />
          <Route path="/ki-kundenservice" element={<KiKundenservice />} />
          <Route path="/gpsr-produktsicherheit" element={<GpsrProduktsicherheit />} />
          <Route path="/custom-software-dashboards" element={<CustomSoftwareDashboards />} />
          <Route path="/webseiten-web-apps" element={<WebseitenWebApps />} />
          <Route path="/big-data-migration" element={<BigDataMigration />} />
          <Route path="/website-crawler" element={<WebsiteCrawler />} />
          <Route path="/ki-vertriebsagenten" element={<KiVertriebsagenten />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;